/**
 * Finds the page ID that contains a given screen ID.
 *
 * @param screenId - The ID of the screen to search for
 * @param yamlObj - The course YAML object with pages and screens
 * @returns The page ID that contains the screen, or null if not found
 */
export default function getPageIdForScreen(
  screenId: string,
  yamlObj: any
): string | null {
  if (!screenId || !yamlObj || !Array.isArray(yamlObj.pages)) return null;

  for (const page of yamlObj.pages) {
    if (!page || !Array.isArray(page.screens)) continue;

    for (const screen of page.screens) {
      if (screen && screen.id === screenId) {
        return page.id;
      }
    }
  }

  return null;
}
